function capitalize(s) {
  // from: https://github.com/see-mike-out/some-useful-js-prototype/blob/main/some_util.js
  if (s.length >= 1) return s[0].toUpperCase() + s.slice(1);
  else return "";
}

export const descriptions = {
  // from big.lp
  remove_data_filter: "Remove a data filter",
  add_data_filter: "Add a data filter",
  aggregate: {
    self: "Aggregate",
    aggregate_q_pos_X_n_pos: "a position channel",
    aggregate_q_pos_X_q_pos_N_n_prop: "a position channel",
    aggregate_count_bin: "with count + binning",
    aggregate_n_bin: "with binning",
    aggregate_n_bin_n_aggregate: "with binning",
    bin_n_bin_n_aggregate: "with binnings"
  },
  remove_mark_label: "Remove mark label(s)",
  adjust_bin_size: "Adjust bin size",
  disaggregate_pos_pos_X_prop: "Disaggregate a position channel",
  disaggregate_count_bin: "Disaggregate a bin with count",
  disaggregate_n_unbin: "Disaggregate with binning",
  disaggregate_n_unbin_n_disaggregate: "Disaggregate with binning",
  unbin_n_unbin_n_disdggregate: "Disaggregate with binning",
  proportionate_resizing: "Resize proportionately",
  disproportionate_resizing: "Resize disproportionately",
  ignore_height: "Ignore height",
  transpose: "Transpose axes",
  partial_transpose_row_to_column: "Partial transpose (R → C)",
  partial_transpose_column_to_row: "Partial transpose (C → R)",
  change_n_facet_columns: "Adjust facet columns",
  make_to_pie_q_X_n: "Convert to a pic chart",
  make_to_pie_q_summed_X_n: "Convert to a pie chart with aggregate",
  make_to_pie_q_X_n_with_agg: "Convert to a pie chart with aggregate",
  make_to_pie_q_X_n_with_remove: "Convert a pie chart with dropping an encoding",
  make_to_pie_q_summed_X_n_with_remove: "Convert a pie chart with dropping an encoding",
  make_to_pie_q_X_n_with_agg_with_remove: "Convert a pie chart with aggregate and dropping an encoding",
  make_heatmap_no_agg: "Convert to a heatmap",
  make_heatmap_no_agg_dup: "Convert to a heatmap",
  make_heatmap_with_agg: "Convert to a heatmap with aggregate",
  make_heatmap_with_agg_dup: "Convert to a heatmap with aggregate",
  make_heatmap_no_agg_remove_channel: "Convert to a heatmap with dropping an encoding",
  make_heatmap_with_agg_remove_channel: "Convert to a heatmap with aggregate and dropping an encoding",
  make_heatmap_nontabular_no_agg_convert_channel: "Convert to a heatmap with converting an encoding",
  make_heatmap_nontabular_with_agg_convert_channel: "Convert to a heatmap with aggregate and converting an encoding",
  make_heatmap_nontabular_with_remove_nominal_channels: "Convert to a heatmap with removing a nominal channel(s)", 
  make_heatmap_adjust_split: "Convert to a heatmap from multiples",
  reverse_cont_scale_after_transpose: "Reverst a scale",
  reposition_mark_label_heatmap: "Repsition mark labels",
  break_heatmap: {
    self: "Convert a heatmap",
    to_bar_grouped: "to grouped bar chart",
    to_bar_multiples: "to bar multiples",
    to_line_withNominalColor: "to lines with color",
    to_line_multiples: "to lines multiples",
    to_point_withNominalColor: "to point with color",
    to_point_multiples: "to point multiples",
    to_point_disagg: "to point with disaggregate",
  },
  oneD_dotplot_to: {
    self: "Convert a dot plot",
    bar: "to a bar chart",
    twoD: "to a scatterplot"
  },
  make_split: {
    self: "Convert to multiples",
    by_field: " by a data field"
  },
  replace_mark_label_to_axis_label: "Replace mark labels to axis labels",
  add_axis_label: "Add axis label(s)",
  bar_to_oneD_dotplot: "Convert a bart chart to a dot plot",
  map_to_bars_n_pos_X_q_pos: "Convert a map to a bart chart",
  add_axis_label_from_map_to_bars: "Add axis labels",
  reposition_mark_label_from_map_to_bar: "Reposition mark labels",
  map_to_multiples: "Convert a map to small multiples",
  add_multiples_label: "Add labels for multiples",
  reposition_legend_from_map_to_multiples: "Reposition a legend",
  rescale_size_channel: "Rescale a size channel",
  remove_channel: "Drop an encoding channel",
  // from small.lp
  convert_axis_label_to_legend: "Convert axis labels to a legend",
  convert_legend_to_axis_label: "Convert a legend to axis labels",
  wrap_text: "Wrap a text element(s)",
  wrap_text_by: "Wrap a text element(s)",
  wrap_annotation_by: "Wrap an annotation(s)",
  unwrap_text: "Unwrap a text elements(s)",
  unwrap_text_by: "Unwrap a text elements(s)",
  unwrap_annotation_by: "Wrap an annotation(s)",
  remove_text: "Remove a text elements(s)",
  remove_annotation: "Remove an annotation(s)",
  externalize_annotation: "Externalize an annotation(s)",
  number_annotation: "Number an externalized annotation(s)",
  internalize_annotation: "Internalize an externalized annotation(s)",
  internalize_title: "Internalize a title as an annotation",
  remove_axis_labels_partial: "Remove axis labels",
  add_axis_label: "Add axis labels",
  add_axis_labels_partial: "Add axis labels",
  simplify_mark_lables_map_to_bar: "Simplify mark labels",
  remove_text_partial: "Remove text elements",
  add_text_partial: "Add text elements",
  reposition_legend: "Reposition legend",
  remove_point_on_mark: "Remove point marks",
  add_point_on_mark: "Add point marks",
  convert_area_to_line: "Convert area to line",
  convert_line_to_area: "Convert line to area",
  remove_end_mark: "Remove line-end mark",
  add_end_mark: "Add line-end mark",
  add_tooltip: "Add a tooltip",
  fix_tooltip: "Fix a tooltip",
  unfix_tooltip: "Unfix a tooltip",
  remove_tooltip: "Remove a tooltip",
  remove_title: "Remove title",
  add_mark_label: "Add mark labels",
  add_legend: "Add legend",
  remove_axis_grid: "Remove axis grid",
  leave_highlights_only: "Leave only highlighted marks",
  invert_circle_mark: "Invert circle marks' fill and stroke"
};

export function getDescription(argList) {
  let descriptions = [];
  argList.forEach(d => {
    let desc = getLineDescription(d);
    if (!descriptions.includes(desc)) descriptions.push(desc)
  });
  return descriptions;
}
function getLineDescription(args) {
  if (descriptions[args[0]]?.constructor.name === "Object") {
    let arg1t = descriptions[args[0]].self;
    let arg2t = descriptions[args[0]][args[1]] || args[1].split("_").join(" ");
    return arg1t + " " + arg2t;
  } else {
    return descriptions[args[0]] || capitalize(args[0]).split("_").join(" ");
  }
}

